import SSBU from "./ssbu/ssbu.module"

const state = {}
const mutations = {}
const actions = {}
const getters = {}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
  modules: {
    SSBU,
  },
}



// WEBPACK FOOTER //
// ./src/store/coaching/games/games.module.js